import * as React from 'react';
import { ModalWindow } from '@cian/ui-kit';

import * as style from './SearchModalLayout.css';

export interface ISearchModalLayoutProps {
  content: React.ReactNode;
  input: React.ReactNode;
  submitButton: React.ReactNode;
  cancelButton: React.ReactNode;
  open: boolean;
  showFooter: boolean;
  onClose: () => void;
}

export const SearchModalLayout: React.FC<ISearchModalLayoutProps> = props => {
  const { content, input, submitButton, cancelButton, open, onClose, showFooter } = props;

  return (
    <ModalWindow
      size="M"
      title={'Поиск'}
      fixed={false}
      open={open}
      onClose={onClose}
      width={800}
      height={'100%'}
      maxHeight={600}
      footer={
        showFooter && (
          <div className={style['footer']}>
            <div className={style['submit_button']}>{submitButton}</div>
            <div className={style['cancel_button']}>{cancelButton}</div>
          </div>
        )
      }
    >
      <div className={style['container']}>
        <div className={style['input']} data-testid="search-input">
          {input}
        </div>
        <div className={style['content']}>{content}</div>
      </div>
    </ModalWindow>
  );
};
